(function($){
	//Handle the mobile menu toggling
	$(".main-menu-toggle").click(function() {
		menuToggle();
	});

	function menuToggle() {
		$(".main-menu-toggle").toggleClass("cross");
		$("body").toggleClass("modal-open");
		$("#mobile-navigation").toggleClass("open");
	}
})(jQuery);
